import i18n from 'i18next';
import { forEach } from 'lodash';
export const DEFAULT_NAMESPACE = 'translation';
export const fallbackLng = 'en-US';
export let getPreferredLocale = (clientLanguage, isLocalizationEnabled, browserLocale) => clientLanguage ?? browserLocale ?? 'en';
export let isAppLocaleInitialized = typeof __IS_MICROFRONTEND__ !== 'undefined'
    ? !!__IS_MICROFRONTEND__
    : false;
export const setAppLocaleInitialised = () => {
    isAppLocaleInitialized = true;
};
export const localeMaster = [
    { id: 'en-AU', displayName: 'English (Australia)', resourceName: 'en-au' },
    { id: 'en-CA', displayName: 'English (Canada)', resourceName: 'en-ca' },
    {
        id: 'en-GB',
        displayName: 'English (United Kingdom)',
        resourceName: 'en-gb',
    },
    {
        id: 'en-US',
        displayName: 'English (United States)',
        resourceName: 'en-us',
    },
    { id: 'de-DE', displayName: 'Deutsch', resourceName: 'de-de' },
    { id: 'de-CH', displayName: 'Deutsch (Switzerland)', resourceName: 'de-ch' },
    { id: 'ja-JP', displayName: '日本語', resourceName: 'ja-jp' },
    { id: 'ko-KR', displayName: '한국어', resourceName: 'ko-kr' },
    { id: 'zh-CN', displayName: '中文 (简体)', resourceName: 'zh-cn' },
    { id: 'zh-Hant', displayName: '中文 (繁體)', resourceName: 'zh-hant' },
    { id: 'pt-BR', displayName: 'Português (Brasil)', resourceName: 'pt-br' },
    { id: 'fr-FR', displayName: 'Français (France)', resourceName: 'fr-fr' },
    { id: 'fr-CA', displayName: 'Français (Canada)', resourceName: 'fr-ca' },
    {
        id: 'es-US',
        displayName: 'Español (United States)',
        resourceName: 'es-us',
    },
    { id: 'da-DK', displayName: 'Dansk', resourceName: 'da-dk' },
    { id: 'es-MX', displayName: 'Español (Mexico)', resourceName: 'es-mx' },
    { id: 'es-ES', displayName: 'Español', resourceName: 'es-es' },
    { id: 'fi-FI', displayName: 'Suomi', resourceName: 'fi-fi' },
    { id: 'sv-SE', displayName: 'Svenska', resourceName: 'sv-se' },
    { id: 'nb-NO', displayName: 'Norsk', resourceName: 'nb-no' },
    { id: 'pt-PT', displayName: 'Português', resourceName: 'pt-pt' },
    { id: 'nl-NL', displayName: 'Nederland', resourceName: 'nl-nl' },
    { id: 'it-IT', displayName: 'Italiano', resourceName: 'it-it' },
    { id: 'tr-TR', displayName: 'Türkçe', resourceName: 'tr-tr' },
    {
        id: 'ru-RU',
        displayName: 'Pусский (ограниченный выпуск)',
        resourceName: 'ru-ru',
    },
    { id: 'en-IN', displayName: 'English (India)', resourceName: 'en-in' },
    { id: 'en-DE', displayName: 'English (Germany)', resourceName: 'en-de' },
    { id: 'en-NZ', displayName: 'English (New Zealand)', resourceName: 'en-nz' },
    { id: 'ro-RO', displayName: 'Română', resourceName: 'ro-ro' },
    { id: 'uk-UA', displayName: 'Українська', resourceName: 'uk-ua' },
    { id: 'pl-PL', displayName: 'Polski', resourceName: 'pl-pl' },
    { id: 'en', resourceName: 'en-us' },
    { id: 'ja', resourceName: 'ja-jp' },
    { id: 'ko', resourceName: 'ko-kr' },
    { id: 'de', resourceName: 'de-de' },
    { id: 'af', resourceName: 'af' },
    { id: 'ru', resourceName: 'ru-ru' },
    { id: 'en-UD', resourceName: 'en-ud' },
];
const getSupportedLocalesMap = () => {
    const supportedLocales = {}, localeIdFromResourceName = {};
    forEach(localeMaster, locale => {
        const { id, resourceName, displayName } = locale;
        if (resourceName) {
            supportedLocales[id] = resourceName;
        }
        if (displayName) {
            localeIdFromResourceName[resourceName] = id;
        }
    });
    return { supportedLocales, localeIdFromResourceName };
};
export const supportedLocalesMap = getSupportedLocalesMap()
    .supportedLocales;
export const localeIdFromResourceName = getSupportedLocalesMap()
    .localeIdFromResourceName;
export function getCurrentLocale() {
    return i18n.language;
}
export const changeLanguage = async (lng) => {
    await i18n.changeLanguage(lng);
};
export const setPreferredLocaleGetter = _getPreferredLocale => {
    getPreferredLocale = _getPreferredLocale;
    const preferredLocale = getPreferredLocale();
    if (preferredLocale !== getCurrentLocale()) {
        changeLanguage();
    }
};
//# sourceMappingURL=i18n.js.map